<template>
    <MainContainer>
        <div class="fibu-op-guthaben">
            <h2>
                <template>Offenen Posten ID {{ id }} mit Guthaben verbuchen</template>
            </h2>
            <b-card class="my-3 bg-light w-100">
                    <h6 class="lead">Infos zum offenen Posten:</h6>
                    <div class="small">
                        <strong>Mitglied:</strong>    {{ op.mitglied }}<br>
                        <strong>Buchungsdatum:</strong>    {{ convertDateString(op.datum) }}<br>
                        <strong>Verwendungszweck:</strong>    {{ op.verwendungszweck_text }}<br>
                        <strong>offener Betrag:</strong>    {{ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(op.balance)) }}
                    </div>
            </b-card>
            <div class="fibu-op-guthaben-fields">
                <FormGroupBuilder
                    :fields="ioFields"
                    :data="data"
                    :refresh="validationRefresh"
                />
                <div class="row">
                    <p class="col-sm-3 col-lg-4 small">offener Betrag</p>
                    <p
                        v-if="parseInt(calcNewOP) < 0"
                        class="col small text-danger"
                    >
                        <strong>{{ calcNewOP }}</strong>
                    </p>
                    <p
                        v-else
                        class="col small"
                    >
                        <strong>{{ calcNewOP }}</strong>
                    </p>
                </div>
                <b-button
                    type="submit"
                    class="total-btn mr-1"
                    variant="primary"
                    :disabled="data.guthaben.length <= 0"
                    @click="dataProvide"
                >
                    <template v-if="!busy">Buchen</template>
                    <template v-else>
                        <Spinner small variant="light" />
                    </template>
                </b-button>
                <b-button
                    type="cancel"
                    to="/fibu/offene_posten"
                    class="total-btn"
                    variant="outline-secondary"
                >
                    <template v-if="checkRight('write')">Abbrechen</template>
                    <template v-else>Zurück</template>
                </b-button>
            </div>
        </div>
    </MainContainer>
</template>

<script>
import Toaster from "@/mixins/Toaster/Toaster";
import Rights from "@/mixins/Rights/Rights";
import Validation from "@/mixins/Validation/Validation";

import {ApiFactory} from "@/api/ApiFactory.js";

import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import Spinner from "@/components/Spinner/Spinner";
import MainContainer from "../../components/MainContainer/MainContainer";

const FiBuOffenePostenApi = ApiFactory.get("fibuOffenePosten");
const FiBuVerwendungszweckApi = ApiFactory.get("fibuVerwendungszweck");

export default {
    name: "OffenePostenGuthaben",
    mixins: [Toaster, Rights, Validation],
    components: {
        MainContainer,
        FormGroupBuilder,
        Spinner
    },
    data() {
        return {
            ioFields: {
                guthaben: {
                    key: 'guthaben',
                    label: 'zu verbuchendes Guthaben',
                    type: 'stackedCheckboxgroup',
                    options: [],
                    busy: false
                }
            },
            data: {
                guthaben: []
            },
            op: {},
            isOverpaid: false,
            busy: false,
            id: this.$route.params.id
        }
    },
    created() {
        this.fetchzuVerbuchendesGuhaben();
        this.fetch();
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await FiBuOffenePostenApi.getSingleForBuchung(this.id);
            if (response.ok) {
                this.registerRights(response);
                this.cleanPayload(response.json);
                const op = response.json;
                this.op = Object.assign(op);
            }
            this.busy = false;
        },
        async fetchVerwendungszweck() {
            this.verwendungszweck.busy = true;
            const response = await FiBuVerwendungszweckApi.get();
            if (response.ok) {
                this.verwendungszweck.items = response.json.collection;
            }
            this.verwendungszweck.busy = false;
        },
        async fetchzuVerbuchendesGuhaben() {
            this.ioFields.guthaben.busy = true;
            const response = await FiBuOffenePostenApi.getGuthaben(this.id);
            if(response.ok) {
                this.ioFields.guthaben.options = response.json.collection.map(item => {
                    return {
                        html: `<strong>${new Intl.NumberFormat(
                                    'de-DE',
                                    {
                                        style: 'currency',
                                        currency: 'EUR'
                                    }).format(Number(item.guthaben))
                                }</strong> <br>
                                (Datum: ${this.convertDateString(item.datum)}, Verwendungszweck: ${item.verwendungszweck})`,
                        value: item
                    };
                });
            }
            this.ioFields.guthaben.busy = false;
        },
        async dataProvide() {
            this.busy = true;

            this.data.opId = this.op.id;
            this.data.balance = this.op.balance;

            var response = await FiBuOffenePostenApi.postGuthabenToOP(this.id, this.data);

            if (response.ok) {
                this.cleanValidationData(this.ioFields);
                this.makeToast(
                    "Erfolgreich gespeichert",
                    "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                );

                if(this.calcNewOP )
                this.$router.push({
                    path: `/fibu/offene_posten`,
                    hash: this.routeParams
                });
            } else {
                this.handleValidationData(response, this.ioFields);
            }
            this.busy = false;
        },
        cleanPayload(json) {
            Object.keys(json).forEach(key => {
                if (key.startsWith("_")) {
                    delete json[key];
                }
            });
        },
        removeMitgliedRel() {
            this.data.mitglied_id = null;
        },
        convertDateString(dateString) {
            let timeStamp = Date.parse(dateString);
            const date = new Date(timeStamp);

            return date.toLocaleDateString(
                'de-DE',
                {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'

                });
        }
    },
    computed: {
        calcNewOP() {
            return new Intl.NumberFormat(
                    'de-DE',
                    {
                        style: 'currency',
                        currency: 'EUR'
                    }).format(Math.min(0, Number(this.op.balance) + this.calcGuthabenOffset));
        },
        calcGuthabenOffset() {
            if(this.data.guthaben.length > 0) {
                return this.data.guthaben.reduce((acc, curr) => acc + Number(curr.guthaben), 0);
            }
            return 0;
        },
        routeParams() {
            return this.op.balance + this.calcGuthabenOffset > 0 ? `#${this.id}` : this.$route.hash;
        }
    }
}
</script>

<style scoped>

</style>